module.exports = __webpack_public_path__ + "img/shachen.b7fa59fa.png";